import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-pink-brand text-white text-xs md:text-sm font-medium py-2 px-4 text-center z-50 relative" data-id="element-1">
      🚚 Envíos a todo México | Tecnología de Grado Farmacéutico
    </div>;
}